import { purchasedProductCardStyles as styles } from "@insite/content-library/Components/PurchasedProductCard";

styles.partNumbersStyles = {
    erpNumberLabelText: {
        weight: "bolder",
    }
}